import PropTypes from 'prop-types';
import React from 'react';
import { InputCpfCnpj } from './styles';
import { normalizeCnpj } from '~/util/document-utils';

function FieldCpfCnpj(props) {
  const { cpfCnpjValue, handleCpfCnpjChange, ...rest } = props;

  const handleInputChange = event => {
    event.target.value = (event.target.value || '').toUpperCase();

    const normalizedState = normalizeCnpj(
      (event.target.value || '').toUpperCase()
    );

    const typedHasLetters = /[A-Z]/.test(normalizedState);

    let forceCnpj = false;
    if (normalizedState.length > 11 || typedHasLetters) {
      forceCnpj = true;
    }

    const mask = forceCnpj ? '__.___.___/____-__' : '___.___.___-__';

    // Para CNPJ, os 2 últimos dígitos devem ser obrigatoriamente números
    let sanitizedState = normalizedState;
    if (forceCnpj && sanitizedState.length > 12) {
      const head = sanitizedState.slice(0, 12);
      const tail = sanitizedState
        .slice(12)
        .replace(/\D/g, '')
        .slice(0, 2);
      sanitizedState = head + tail;
    }

    let filledMask = mask;
    let inputIndex = 0;
    filledMask = mask.replace(/_/g, () => {
      if (inputIndex < sanitizedState.length) {
        return sanitizedState[inputIndex++];
      }
      return '_';
    });

    let cursorPosition = filledMask.indexOf('_');
    if (cursorPosition === -1) {
      cursorPosition = filledMask.length;
    }

    event.target.value = filledMask;
    event.target.selectionStart = cursorPosition;
    event.target.selectionEnd = cursorPosition;
    event.target.focus();
    handleCpfCnpjChange(event);
  };

  const handleKeyDown = event => {
    if (event.key !== 'Backspace') return;

    const input = event.target;
    const { value, selectionStart, selectionEnd } = input;

    // Apenas quando não há seleção em range
    if (selectionStart !== selectionEnd) return;

    const maskSeparators = /[.\-/]/;

    if (selectionStart >= 1 && maskSeparators.test(value[selectionStart - 1])) {
      event.preventDefault();
      const charsToRemove = selectionStart >= 2 ? 2 : 1;
      const newValue =
        value.slice(0, selectionStart - charsToRemove) +
        value.slice(selectionStart);

      // Dispara o onChange do React via setter nativo
      const nativeSetter = Object.getOwnPropertyDescriptor(
        window.HTMLInputElement.prototype,
        'value'
      ).set;
      nativeSetter.call(input, newValue);
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  };

  return (
    <InputCpfCnpj
      type="text"
      value={cpfCnpjValue}
      onChange={handleInputChange}
      onKeyDown={handleKeyDown}
      {...rest}
    />
  );
}

FieldCpfCnpj.propTypes = {
  cpfCnpjValue: PropTypes.string,
  handleCpfCnpjChange: PropTypes.func,
};

export { FieldCpfCnpj };
